import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import styles from "./style.scss";
import {
  FinancialChartReference,
  MacroChartReference,
  MacroIrChartReference
} from "models/AiResearch";

export interface Props {
  reference:
    | FinancialChartReference
    | MacroIrChartReference
    | MacroChartReference;
  onClick: () => void;
}

export const Graph: React.FC<Props> = ({ reference, onClick }) => {
  const options: Highcharts.Options = {
    title: {
      text: ""
    },
    yAxis: {
      title: undefined,
      gridLineWidth: 1,
      tickAmount: 4,
      tickPixelInterval: 20,
      labels: {
        formatter() {
          return Highcharts.numberFormat(this.value as number, 0);
        },
        style: {
          fontSize: "5px"
        }
      }
    },
    xAxis: {
      title: undefined,
      categories: reference.data.content.series[0].values.map(v => v.x),
      labels: {
        style: {
          fontSize: "5px"
        }
      },
      gridLineWidth: 1,
      gridLineColor: "#e6e6e6"
    },
    series: [
      {
        type:
          reference.dataType === "macro_chart" ||
          reference.dataType === "macro_ir_chart"
            ? "column"
            : reference.data.content.chartType,
        data: reference.data.content.series[0].values.map(v => v.y),
        name: ""
      }
    ],
    chart: {
      height: 108,
      width: 182
    },
    exporting: {
      enabled: false
    },
    legend: {
      enabled: false // 凡例非表示
    },
    credits: {
      enabled: false
    }
  };

  return (
    <div
      className={styles.container}
      onClick={onClick}
      data-reference-button="true"
    >
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};
